import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

interface DialogData {
  id: number;
}

@Component({
  selector: 'user-modal-defects-list',
  templateUrl: './modal-defects-list.component.html',
  styleUrls: ['./modal-defects-list.component.scss']
})
export class ModalDefectsListComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalDefectsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
